import { TranslatePipe, TranslateService } from "@ngx-translate/core";

import { DecimalPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";

import { KpiDaysKeyPipe } from "../../../../../helpers/kpi/kpi-days-key.pipe";
import { KpiItem, getStatusColor } from "../../../../../helpers/kpi/kpi-item";

interface FormattedKpi {
  days: number;
  values: { value: number; kpi: KpiItem }[];
}

@Component({
  selector: "kpi-data",
  templateUrl: "kpi-data.html",
  styleUrls: ["../../kpi-table.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DecimalPipe, KpiDaysKeyPipe, MatTooltipModule, TranslatePipe],
})
export class KpiData {
  private translate = inject(TranslateService);

  title = input.required<string>();
  kpiItems = input.required<KpiItem[]>();
  kpiRows = input.required<FormattedKpi[]>();

  protected allRowsEmpty = computed(() => this.kpiRows().every((row) => row.values.length === 0));

  getStatus = getStatusColor;

  getHeaderTooltip(kpi: KpiItem): string {
    const name = this.translate.instant(kpi.name);
    const unit = kpi.unit ? ` ${kpi.unit}` : "";
    return `${name} (Warning ${kpi.warning.label}${unit}, Error ${kpi.danger.label}${unit})`;
  }
}
